function Code() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      fill='currentColor'
      enableBackground="new 0 0 35.033 35.033"
      version="1.1"
      viewBox="0 0 35.033 35.033"
      xmlSpace="preserve"
    >
      <path d="M11.811 10.535l-6.983 6.984 6.983 6.981a2.001 2.001 0 01-1.414 3.414 1.988 1.988 0 01-1.414-.586L.586 18.932a1.997 1.997 0 010-2.827l8.397-8.398a2.001 2.001 0 012.828 0c.78.781.78 2.045 0 2.828zm22.636 5.569l-8.396-8.398a2 2 0 10-2.828 2.828l6.982 6.984-6.982 6.982a2 2 0 102.828 2.828l8.396-8.396a2 2 0 000-2.828zM21.012 3.831a1.998 1.998 0 00-2.435 1.441l-6 23.498a2.003 2.003 0 001.939 2.497c.894 0 1.706-.603 1.937-1.505l6-23.498a2 2 0 00-1.441-2.433z"></path>
    </svg>
  );
}

export default Code;
